import { FlexAligner, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { KeyboardKeyWithOptionalIcon } from '@/components/hotKeyLineWithButtonAndDescription/KeyboardKeyWithOptionalIcon.tsx';
import { KeyboardModifierWithOptionalIcon } from '@/components/hotKeyLineWithButtonAndDescription/KeyboardModifierWithOptionalIcon.tsx';
import { MenuIconWrapper } from '@/components/hotKeyLineWithButtonAndDescription/shortCut.styles.ts';
import { Hotkey } from '@/hooks/shortcutHooks/hotkeys/types.ts';
import { responsive } from '@/utils';

import { NoWrapTypography } from '../pages/bargeControl/styles.ts';

export const HotKeyLineWithButtonAndDescription = ({
  description,
  hotkeyModifier,
  menuIconBackground,
  menuIconForAction,
  mouseAction,
  optionalPrimary,
  primary: { keyboardKey },
  secondary,
  secondaryHotkeyModifier,
}: Hotkey) => {
  const { t } = useTranslation(['common']);
  const secondaryKeyboardKey = secondary?.keyboardKey;
  return (
    <FlexAligner fullWidth spaceBetween alignment={'center'}>
      <FlexAligner fullWidth={false} alignment={'center'} gap={responsive.spacing.large}>
        <KeyboardModifierWithOptionalIcon hotkeyModifier={hotkeyModifier} />
        <KeyboardModifierWithOptionalIcon hotkeyModifier={secondaryHotkeyModifier} />
        <KeyboardKeyWithOptionalIcon keyboardKey={keyboardKey} />
        {optionalPrimary && (
          <>
            <Typography>{t('common:or').toLocaleLowerCase()}</Typography>
            <KeyboardKeyWithOptionalIcon keyboardKey={optionalPrimary.keyboardKey} />
          </>
        )}
        {secondaryKeyboardKey && (
          <>
            <Typography>{'+'}</Typography>
            <KeyboardKeyWithOptionalIcon keyboardKey={secondaryKeyboardKey} />
          </>
        )}
        {mouseAction && <NoWrapTypography>({t(`common:${mouseAction}`)})</NoWrapTypography>}
      </FlexAligner>
      <FlexAligner
        alignment={'center-right'}
        direction={'row'}
        fullHeight
        gap={responsive.spacing['4xlarge']}
        style={{ paddingLeft: responsive.spacing.large, paddingRight: responsive.spacing.large }}
      >
        <Typography type='body_large' style={{ textAlign: 'center', textWrapMode: 'nowrap' }}>
          {description}
        </Typography>
        {menuIconForAction && (
          <MenuIconWrapper $menuIconBackground={menuIconBackground}>
            {menuIconForAction}
          </MenuIconWrapper>
        )}
      </FlexAligner>
    </FlexAligner>
  );
};
